var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 11.8747V4.45801C4.75 4.22231 4.75 4.10445 4.82322 4.03123C4.89645 3.95801 5.0143 3.95801 5.25 3.95801H13.0429C13.5566 3.95801 13.8135 3.95801 13.8774 4.11234C13.9413 4.26667 13.7597 4.4483 13.3964 4.81156L10.5745 7.6335C10.4412 7.76683 10.3745 7.8335 10.3745 7.91634C10.3745 7.99918 10.4412 8.06585 10.5745 8.19918L13.3964 11.0211C13.7597 11.3844 13.9413 11.566 13.8774 11.7203C13.8135 11.8747 13.5566 11.8747 13.0429 11.8747H4.75ZM4.75 11.8747V15.0413",
    stroke: "#E1242A",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.b829698f65aca5cc6b547f62d7b0a712.svg";
export { ForwardRef as ReactComponent };